export const TENANT_ROLES = ["admin", "assessor", "contributor", "auditor", "viewer"];
const MATRIX = {
    admin: ["system.read", "system.write", "system.delete", "control.write", "member.read", "member.manage", "audit.read", "export"],
    assessor: ["system.read", "system.write", "control.write", "member.read", "export"],
    contributor: ["system.read", "control.write", "member.read"],
    auditor: ["system.read", "member.read", "audit.read", "export"],
    viewer: ["system.read", "member.read"],
};
export const ROLE_LABELS = {
    admin: { name: "Admin", summary: "Everything, including members and the audit trail" },
    assessor: { name: "Assessor", summary: "Edit systems, profiles and controls" },
    contributor: { name: "Contributor", summary: "Update control status and evidence" },
    auditor: { name: "Auditor", summary: "Read everything, including the audit trail" },
    viewer: { name: "Viewer", summary: "Read systems and controls" },
};
export function can(role, action, platformAdmin = false) {
    if (platformAdmin)
        return true;
    if (!role)
        return false;
    return MATRIX[role].includes(action);
}
//# sourceMappingURL=permissions.js.map